export default __webpack_public_path__ + "static/grid-img-default-121a9c03f8751b7d6573b3049a63f7ee.jpg";